import { Mappable } from "../../_shared/mappable.class";

export class FundraisingSite extends Mappable<FundraisingSite> {

    name: string;
    logoUrl: string;
    primaryColor: string;
    secondaryColor: string;
    legalUrl: string;
    faq: FaqItem[];
    bannerUrl: string;
    sponsorUrl: string;
    advertisementName: string;
    advertisementText: string;
    advertisementUrl: string;
    vendorId: number;
    vendorName: string;
    baseQRUrl: string;
}

export interface FaqItem extends Mappable<FaqItem>{
    head: string;
    paragraph: string;
}